module.exports = __webpack_public_path__ + "img/cover.3f846dab.svg";